import { render, staticRenderFns } from "./StartLearningToday.vue?vue&type=template&id=648aa6f0&scoped=true&"
import script from "./StartLearningToday.vue?vue&type=script&lang=js&"
export * from "./StartLearningToday.vue?vue&type=script&lang=js&"
import style0 from "./StartLearningToday.vue?vue&type=style&index=0&id=648aa6f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648aa6f0",
  null
  
)

export default component.exports